import styled from 'styled-components';
import React, { useEffect, useState } from 'react';
import { Progress } from 'semantic-ui-react';
import CopilotIcon from 'common/components/icons/Copilot';

const defaultChatbotIntroLines = [
  'Gathering insights',
  'Connecting to our knowledge base...',
  'Processing your query...',
  'Generating insights...',
  'Summarizing your query...',
  'Compiling your response...',
];

const AwaitingQuery = ({ context_length, introLines = defaultChatbotIntroLines, maxContentWidth = '520px' }) => {
  const [waitingText, setWaitingText] = useState(introLines[0] || 'Gathering insights');
  const [progress, setProgress] = useState(0);
  const [currentIndex, setCurrentIndex] = useState(0);

  const get_time = () => {
    if (context_length < 100) {
      return 20;
    }
    if (context_length < 200) {
      return 80;
    }
    return 150;
  };

  useEffect(() => {
    let interval;

    if (currentIndex < introLines.length - 1) {
      interval = setInterval(() => {
        setCurrentIndex(prevIndex => {
          const nextIndex = prevIndex + 1;
          if (nextIndex < introLines.length) {
            setWaitingText(introLines[nextIndex]);
          }
          return nextIndex;
        });
      }, 4000);
    }

    return () => {
      if (interval) {
        clearInterval(interval);
      }
    };
  }, [currentIndex, introLines]);

  useEffect(() => {
    const timer = setInterval(() => {
      setProgress(prevProgress => (prevProgress >= 100 ? 100 : prevProgress + 1));
    }, get_time());

    return () => clearInterval(timer);
  }, [context_length]);

  return (
    <Container>
      <Circle>{CopilotIcon()}</Circle>
      <Message maxWidth={maxContentWidth}>
        <Description>
          <LoadingText>{waitingText}</LoadingText>
          <Progress percent={progress} indicating size="tiny" />
        </Description>
      </Message>
    </Container>
  );
};

export default AwaitingQuery;

const Container = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin-bottom: 60px;
  align-items: flex-start;
`;

const Circle = styled.div`
  width: 40px;
  height: 40px;
  border-radius: 10px;
  background-color: #2d70e2;
  color: #ffffff;
  min-width: 40px;
  align-items: center;
  display: flex;
  justify-content: center;
`;

const Message = styled.div`
  display: inline-flex;
  flex-direction: column;
  width: ${props => props.maxWidth || '520px'};
  max-width: ${props => props.maxWidth || '520px'};
  min-width: ${props => props.maxWidth || '520px'};
  align-self: flex-start;
  background: #F8FAFF;
  padding: 16px;
  border-radius: 8px;
`;

const LoadingText = styled.div`
  font-family: 'Poppins', sans-serif;
  font-style: normal;
  align-content: center;
  font-size: 14px;
  color: #2a3039;
  margin-bottom: 5px;
  &::after {
    display: inline-block;
    animation: ellipsis 1.25s infinite;
    content: '.';
    width: 1em;
    text-align: left;
  }
  @keyframes ellipsis {
    0% {
      content: '.';
    }
    33% {
      content: '..';
    }
    66% {
      content: '...';
    }
  }
`;

const Description = styled.div`
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  color: ${props => (props.error ? '#F15062' : '#2A3039')};
  white-space: pre-wrap;
  width: 100%;
  max-width: ${props => props.maxWidth || '100%'};
  min-width: 0;
  word-break: break-word;
`;
